// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 19 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.1656 1.66406V10.8307M17.3322 8.16406V4.33073C17.3322 3.39731 17.3322 2.9306 17.1506 2.57408C16.9908 2.26047 16.7358 2.00551 16.4222 1.84572C16.0657 1.66406 15.599 1.66406 14.6656 1.66406H5.76391C4.54601 1.66406 3.93706 1.66406 3.44522 1.88692C3.01174 2.08334 2.64332 2.39941 2.38327 2.79799C2.08821 3.25022 1.99562 3.85209 1.81043 5.05583L1.37453 7.88917C1.13027 9.47682 1.00815 10.2707 1.24374 10.8883C1.45052 11.4305 1.83945 11.8838 2.34384 12.1706C2.91851 12.4974 3.72168 12.4974 5.32802 12.4974H5.99891C6.46562 12.4974 6.69897 12.4974 6.87723 12.5882C7.03403 12.6681 7.16152 12.7956 7.24141 12.9524C7.33224 13.1307 7.33224 13.364 7.33224 13.8307V16.2759C7.33224 17.4107 8.25223 18.3307 9.3871 18.3307C9.65779 18.3307 9.90309 18.1713 10.013 17.924L12.8137 11.6225C12.941 11.3359 13.0047 11.1926 13.1054 11.0876C13.1944 10.9947 13.3037 10.9236 13.4247 10.8801C13.5616 10.8307 13.7184 10.8307 14.0321 10.8307H14.6656C15.599 10.8307 16.0657 10.8307 16.4222 10.6491C16.7358 10.4893 16.9908 10.2343 17.1506 9.92071C17.3322 9.56419 17.3322 9.09748 17.3322 8.16406Z"
    />
  </svg>
);
const IconThumbDown = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconThumbDown;
